import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './general-meter-gas-meter-lg.svg';
import md from './general-meter-gas-meter-md.svg';
import sm from './general-meter-gas-meter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.GENERAL_METER_GAS_METER,
  label: 'Allgemeinzähler Gaszähler',
  shortLabel: 'ALLGAS',
  icons: { sm, md, lg },
  component: component('general-meter-gas-meter/GeneralMeterGasMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('general-meter-gas-meter/GeneralMeterGasMeterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
